import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getFiles = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.file.files.entries, filter);
};
